<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="ts-mb-4 ts-flex ts-justify-between">
        <div class="ts-flex ts-items-center ts-space-x-2">
          <a-select
            v-model="branch_id"
            mode="multiple"
            :placeholder="$t('studentInsurance.selectBranch')"
            show-search
            :filter-option="filterOption"
            option-filter-prop="children"
            style="width: 230px"
            :options="branchOptionns"
            :maxTagTextLength="10"
            :maxTagCount="1"
            allowClear
            @change="fetchAcademicYear"
          ></a-select>
          <a-select
            v-model="ac_year_id"
            mode="multiple"
            :placeholder="$t('studentInsurance.selectAcademicYear')"
            style="width: 230px"
            :maxTagTextLength="25"
            :maxTagCount="1"
            allowClear
          >
            <a-select-opt-group
              v-for="(option, index) in acYearOptionns"
              :key="index"
            >
              <span slot="label">{{ option.label }}</span>
              <a-select-option
                v-for="(opt, index) in option.options"
                :key="index"
                :value="opt.value"
              >
                {{ opt.label }}
              </a-select-option>
            </a-select-opt-group>
          </a-select>
          <a-range-picker
            v-model="dateRange"
 
 mo           format="DD-MM-YYYY"
            valueFormat="YYYY-MM-DD"
            style="max-width: 200px;"
          >
          </a-range-picker>
          <a-radio-group v-model="is_new_student" button-style="solid">
            <a-radio-button :value="undefined">
              {{ $t('studentInsurance.all') }}
            </a-radio-button>
            <a-radio-button :value="1">
              {{ $t('studentInsurance.new') }}
            </a-radio-button>
            <a-radio-button :value="0">
              {{ $t('studentInsurance.old') }}
            </a-radio-button>
          </a-radio-group>
        </div>
        <div class="ts-space-x-3">
          <a-tooltip placement="topLeft">
            <template slot="title">
              <span>{{ $t('studentInsurance.search') }}</span>
            </template>
            <a-input-search
              v-model="search"
              @search="fetchData({ search: search })"
              :placeholder="$t('studentInsurance.search')"
              style="width: 200px"
            />
          </a-tooltip>
          <a-button type="primary" @click="fetchData">
            {{ $t('search') }}
          </a-button>
          <a-button @click.prevent="exportExcel" type="dashed">
            <span class="ts-mr-2">{{ $t('excel') }}</span>
            <i class="fas fa-file-excel"></i>
          </a-button>
        </div>
      </div>
      <div class="ts-overflow-auto" style="min-height: 300px;">
        <table class="ts-w-full">
          <thead>
            <tr>
              <th
                class="ts-font-semibold ts-border-b ts-border-t ts-border-gray-500 ts-whitespace-no-wrap ts-py-1 ts-px-2 ts-bg-gray-100 ts-w-10"
                rowspan="2"
              >
                {{ $t('studentInsurance.no') }}
              </th>
              <th
                class="ts-font-semibold ts-border-b ts-border-t ts-border-gray-500 ts-whitespace-no-wrap ts-py-1 ts-px-2 ts-bg-gray-100 ts-w-48"
                rowspan="2"
              >
                <div class="ts-flex ts-items-center">
                  {{ $t('studentInsurance.branch') }}
                  <div
                    class="ts-ml-1 ts-cursor-pointer"
                    @click="handleOrder('branch_name_en')"
                  >
                    <i class="fas fa-sort ts-text-gray-400"></i>
                  </div>
                </div>
              </th>
              <th
                class="ts-font-semibold ts-border-b ts-border-t ts-border-gray-500 ts-whitespace-no-wrap ts-py-1 ts-px-2 ts-bg-gray-100"
                rowspan="2"
              >
                <div class="ts-flex ts-items-center">
                  {{ $t('studentInsurance.academicYear') }}
                  <div
                    class="ts-ml-1 ts-cursor-pointer"
                    @click="handleOrder('ac_year')"
                  >
                    <i class="fas fa-sort ts-text-gray-400"></i>
                  </div>
                </div>
              </th>
              <th
                class="ts-font-semibold ts-border-b ts-border-t ts-border-gray-500 ts-whitespace-no-wrap ts-py-1 ts-px-2 ts-bg-gray-100"
                rowspan="2"
              >
                <div class="ts-flex ts-items-center">
                  {{ $t('studentInsurance.studentName') }}
                  <div
                    class="ts-ml-1 ts-cursor-pointer"
                    @click="handleOrder('full_name_en')"
                  >
                    <i class="fas fa-sort ts-text-gray-400"></i>
                  </div>
                </div>
              </th>
              <th
                class="ts-font-semibold ts-border-b ts-border-t ts-border-gray-500 ts-whitespace-no-wrap ts-py-1 ts-px-2 ts-bg-gray-100"
                rowspan="2"
              >
                <div class="ts-flex ts-items-center">
                  {{ $t('studentInsurance.studentId') }}
                  <div
                    class="ts-ml-1 ts-cursor-pointer"
                    @click="handleOrder('card_number')"
                  >
                    <i class="fas fa-sort ts-text-gray-400"></i>
                  </div>
                </div>
              </th>
              <th
                class="ts-font-semibold ts-border-b ts-border-t ts-border-gray-500 ts-whitespace-no-wrap ts-py-1 ts-px-2 ts-bg-gray-100"
                rowspan="2"
              >
                {{ $t('studentInsurance.dateOfBirth') }}
              </th>
              <th
                class="ts-font-semibold ts-border-b ts-border-t ts-border-gray-500 ts-whitespace-no-wrap ts-py-1 ts-px-2 ts-bg-gray-100"
                rowspan="2"
              >
                {{ $t('studentInsurance.gender') }}
              </th>
              <th
                class="ts-font-semibold ts-border-b ts-border-t ts-border-gray-500 ts-whitespace-no-wrap ts-py-1 ts-px-2 ts-bg-gray-100"
                rowspan="2"
              >
                {{ $t('studentInsurance.nationality') }}
              </th>
              <th
                class="ts-font-semibold ts-border-b ts-border-t ts-border-gray-500 ts-whitespace-no-wrap ts-py-1 ts-px-2 ts-bg-gray-100"
                rowspan="2"
              >
                {{ $t('studentInsurance.phoneNumber') }}
              </th>
              <th
                class="ts-font-semibold ts-border-b ts-border-t ts-border-gray-500 ts-whitespace-no-wrap ts-py-1 ts-px-2 ts-bg-gray-100"
                rowspan="2"
              >
                {{ $t('studentInsurance.course') }}
              </th>
              <th
                class="ts-font-semibold ts-border-b ts-border-t ts-border-gray-500 ts-whitespace-no-wrap ts-py-1 ts-px-2 ts-bg-gray-100"
                rowspan="2"
              >
                {{ $t('studentInsurance.enrollmentDate') }}
              </th>
              <th
                class="ts-font-semibold ts-border-b ts-border-t ts-border-gray-500 ts-whitespace-no-wrap ts-py-1 ts-px-2 ts-bg-gray-100 ts-text-center"
                colspan="6"
              >
                {{ $t('studentInsurance.legalGuardian') }} 1
              </th>
              <th
                class="ts-font-semibold ts-border-b ts-border-t ts-border-gray-500 ts-whitespace-no-wrap ts-py-1 ts-px-2 ts-bg-gray-100 ts-text-center"
                colspan="6"
              >
                {{ $t('studentInsurance.legalGuardian') }} 2
              </th>
              <th
                class="ts-font-semibold ts-border-b ts-border-t ts-border-gray-500 ts-whitespace-no-wrap ts-py-1 ts-px-2 ts-bg-gray-100 ts-text-center"
                rowspan="2"
              >
                {{ $t('studentInsurance.approved') }}
              </th>
              <th
                class="ts-font-semibold ts-border-b ts-border-t ts-border-gray-500 ts-whitespace-no-wrap ts-py-1 ts-px-2 ts-bg-gray-100 ts-text-center"
                rowspan="2"
              >
                {{ $t('actions') }}
              </th>
            </tr>
            <tr>
              <th
                class="ts-bg-gray-100 ts-font-semibold ts-border-gray-500 ts-whitespace-no-wrap ts-border-b ts-py-1 ts-px-2"
              >
                {{ $t('studentInsurance.name') }}
              </th>
              <th
                class="ts-bg-gray-100 ts-font-semibold ts-border-gray-500 ts-whitespace-no-wrap ts-border-b ts-py-1 ts-px-2"
              >
                {{ $t('studentInsurance.gender') }}
              </th>
              <th
                class="ts-bg-gray-100 ts-font-semibold ts-border-gray-500 ts-whitespace-no-wrap ts-border-b ts-py-1 ts-px-2"
              >
                {{ $t('studentInsurance.phoneNumber') }}
              </th>
              <th
                class="ts-bg-gray-100 ts-font-semibold ts-border-gray-500 ts-whitespace-no-wrap ts-border-b ts-py-1 ts-px-2"
              >
                {{ $t('studentInsurance.relationShip') }}
              </th>
              <th
                class="ts-bg-gray-100 ts-font-semibold ts-border-gray-500 ts-whitespace-no-wrap ts-border-b ts-py-1 ts-px-2"
              >
                {{ $t('studentInsurance.proportion') }} %
              </th>
              <th
                class="ts-bg-gray-100 ts-font-semibold ts-border-gray-500 ts-whitespace-no-wrap ts-border-b ts-py-1 ts-px-2"
              >
                {{ $t('studentInsurance.remark') }}
              </th>
              <th
                class="ts-bg-gray-100 ts-font-semibold ts-border-gray-500 ts-whitespace-no-wrap ts-border-b ts-py-1 ts-px-2"
              >
                {{ $t('studentInsurance.name') }}
              </th>
              <th
                class="ts-bg-gray-100 ts-font-semibold ts-border-gray-500 ts-whitespace-no-wrap ts-border-b ts-py-1 ts-px-2"
              >
                {{ $t('studentInsurance.gender') }}
              </th>
              <th
                class="ts-bg-gray-100 ts-font-semibold ts-border-gray-500 ts-whitespace-no-wrap ts-border-b ts-py-1 ts-px-2"
              >
                {{ $t('studentInsurance.phoneNumber') }}
              </th>
              <th
                class="ts-bg-gray-100 ts-font-semibold ts-border-gray-500 ts-whitespace-no-wrap ts-border-b ts-py-1 ts-px-2"
              >
                {{ $t('studentInsurance.relationShip') }}
              </th>
              <th
                class="ts-bg-gray-100 ts-font-semibold ts-border-gray-500 ts-whitespace-no-wrap ts-border-b ts-py-1 ts-px-2"
              >
                {{ $t('studentInsurance.proportion') }} %
              </th>
              <th
                class="ts-bg-gray-100 ts-font-semibold ts-border-gray-500 ts-whitespace-no-wrap ts-border-b ts-py-1 ts-px-2"
              >
                {{ $t('studentInsurance.remark') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!resources.length">
              <td colspan="23" class="ts-text-center ts-py-20">
                <i class="fas fa-folder-open fa-4x ts-text-gray-400"></i>
                <p>{{ $t('studentInsurance.noData') }}</p>
              </td>
            </tr>
            <tr v-for="(r, index) in resources" :key="index">
              <td class="ts-border-b ts-whitespace-no-wrap ts-py-1 ts-px-2">
                {{ index + 1 }}
              </td>
              <td class="ts-border-b ts-whitespace-no-wrap ts-py-1 ts-px-2">
                {{ r.branch_name_en }}
              </td>
              <td class="ts-border-b ts-whitespace-no-wrap ts-py-1 ts-px-2">
                {{ r.ac_year }}
              </td>
              <td class="ts-border-b ts-whitespace-no-wrap ts-py-1 ts-px-2">
                {{ r.full_name_en }}
                <span class="ts-text-xs ts-text-red-500">
                  <i>{{ r.is_new_student ? ' (New)' : '(Old)' }}</i>
                </span>
              </td>
              <td class="ts-border-b ts-whitespace-no-wrap ts-py-1 ts-px-2">
                {{ r.card_number }}
              </td>
              <td class="ts-border-b ts-whitespace-no-wrap ts-py-1 ts-px-2">
                {{ r.date_of_birth }}
              </td>
              <td class="ts-border-b ts-whitespace-no-wrap ts-py-1 ts-px-2">
                {{ r.gender }}
              </td>
              <td class="ts-border-b ts-whitespace-no-wrap ts-py-1 ts-px-2">
                {{ r.nationality }}
              </td>
              <td class="ts-border-b ts-whitespace-no-wrap ts-py-1 ts-px-2">
                {{ r.phone }}
              </td>
              <td class="ts-border-b ts-whitespace-no-wrap ts-py-1 ts-px-2">
                {{ r.acps_abbr }}
              </td>
              <td class="ts-border-b ts-whitespace-no-wrap ts-py-1 ts-px-2">
                {{ r.created_at }}
              </td>
              <td class="ts-border-b ts-whitespace-no-wrap ts-py-1 ts-px-2">
                {{ getLegal(1, r.benificiaries).name_en }}
              </td>
              <td class="ts-border-b ts-whitespace-no-wrap ts-py-1 ts-px-2">
                {{ getLegal(1, r.benificiaries).gender }}
              </td>
              <td class="ts-border-b ts-whitespace-no-wrap ts-py-1 ts-px-2">
                {{ getLegal(1, r.benificiaries).phone_number }}
              </td>
              <td class="ts-border-b ts-whitespace-no-wrap ts-py-1 ts-px-2">
                {{ getLegal(1, r.benificiaries).relationship }}
              </td>
              <td class="ts-border-b ts-whitespace-no-wrap ts-py-1 ts-px-2">
                {{ getLegal(1, r.benificiaries).benificiary_pro }}
              </td>
              <td class="ts-border-b ts-whitespace-no-wrap ts-py-1 ts-px-2">
                {{ getLegal(1, r.benificiaries).remark }}
              </td>
              <td class="ts-border-b ts-whitespace-no-wrap ts-py-1 ts-px-2">
                {{ getLegal(2, r.benificiaries).name_en }}
              </td>
              <td class="ts-border-b ts-whitespace-no-wrap ts-py-1 ts-px-2">
                {{ getLegal(2, r.benificiaries).gender }}
              </td>
              <td class="ts-border-b ts-whitespace-no-wrap ts-py-1 ts-px-2">
                {{ getLegal(2, r.benificiaries).phone_number }}
              </td>
              <td class="ts-border-b ts-whitespace-no-wrap ts-py-1 ts-px-2">
                {{ getLegal(2, r.benificiaries).relationship }}
              </td>
              <td class="ts-border-b ts-whitespace-no-wrap ts-py-1 ts-px-2">
                {{ getLegal(2, r.benificiaries).benificiary_pro }}
              </td>
              <td class="ts-border-b ts-whitespace-no-wrap ts-py-1 ts-px-2">
                {{ getLegal(2, r.benificiaries).remark }}
              </td>
              <td
                class="ts-border-b ts-text-center ts-whitespace-no-wrap ts-py-1 ts-px-2"
              >
                <span
                  v-if="r.approved"
                  class="ts-px-2 ts-bg-green-100 ts-text-green-500 ts-rounded-md"
                  >Yes</span
                >
                <span
                  v-else
                  class="ts-px-2 ts-bg-red-100 ts-text-red-500 ts-rounded-md"
                  >No</span
                >
              </td>
              <td
                class="ts-border-b ts-text-center ts-whitespace-no-wrap ts-py-1 ts-px-2 ts-flex ts-items-center ts-space-x-2"
              >
                <a href="#" v-if="!r.approved" @click.prevent="onEdit(r)">
                  <i class="fas fa-user-edit"></i>
                </a>

                <i
                  class="fas fa-user-check ts-text-green-500"
                  v-if="r.approved"
                ></i>

                <a
                  href="#"
                  v-tooltip="$t('studentprofile.insurance')"
                  class="mr-2 text-primary"
                  @click.prevent="insurance(r)"
                >
                  <i class="fas fa-hand-holding-heart"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ts-loading-banner>
    <div class="d-flex justify-content-between align-items-center p-15">
      <ts-total-list v-model="pagination" />
      <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
    </div>

    <a-modal
      v-if="showModal"
      v-model="showModal"
      centered
      :footer="null"
      :title="$t('studentInsurance.acknowledge')"
    >
      <insuranceAcknowledge :editData="editData" @fetch="onCloseModal" />
    </a-modal>

    <a-modal
      v-model="showInsurance"
      v-if="showInsurance"
      :title="$t('studentprofile.insurance')"
      :footer="null"
      width="700px"
    >
      <Insurance :studentInsurance="studentInsurance" @close="onCloseModal" />
    </a-modal>
  </div>
</template>

<script>
import * as FileDownload from 'downloadjs'
import { camelCase, mapKeys, trim } from 'lodash'
import moment from 'moment'
import { mapActions } from 'vuex'
import Insurance from '../../student-profile/component/insurance.vue'
import insuranceAcknowledge from './insurance-acknowledge.vue'

class Pagination {
  constructor(paging = {}) {
    this.currentPage = paging.currentPage ? parseInt(paging.currentPage) : 1
    this.lastPage = paging.lastPage ? parseInt(paging.lastPage) : 0
    this.perPage = paging.perPage ? parseInt(paging.perPage) : 15
    this.total = paging.total ? parseInt(paging.total) : 0
    this.from = this.perPage * (this.currentPage - 1) + 1
    this.to = this.perPage * this.currentPage
  }
}

export default {
  name: 'insuranceTable',
  props: {
    branches: {
      type: Array,
      default: () => []
    }
  },
  components: {
    insuranceAcknowledge,
    Insurance
  },
  data() {
    return {
      pagination: new Pagination(),
      loading: false,
      showModal: false,
      editData: {},
      resources: [],
      acYearOptionns: [],
      showInsurance: false,
      studentInsurance: undefined,
      branch_id: undefined,
      ac_year_id: undefined,
      search: undefined,
      is_new_student: undefined,
      dateRange: [
        moment().format('YYYY-MM-DD'),
        moment().format('YYYY-MM-DD')
      ]
    }
  },

  async mounted() {
    this.branch_id = this.$store.state.authUser.default_branch_id || undefined
    await this.fetchAcademicYear()
    await this.fetchData()
  },
  computed: {
    branchOptionns() {
      return this.branches.map(branch => ({
        value: branch.branch_id,
        label: branch.branch_name_en
      }))
    },
    getLegal: () => (order, beneficiaries) => {
      // Default empty beneficiary object
      const emptyBeneficiary = {
        id: undefined,
        student_id: undefined,
        order: undefined,
        name_kh: undefined,
        name_en: undefined,
        gender: undefined,
        phone_number: undefined,
        relationship: undefined,
        benificiary_pro: undefined,
        remark: undefined
      }

      // Check if beneficiaries array exists and has items
      if (!beneficiaries || beneficiaries.length === 0) {
        return emptyBeneficiary
      }

      // Find the beneficiary with matching order
      const found = beneficiaries.find(b => b.order === order)

      // Return the found beneficiary or the empty default
      return found || emptyBeneficiary
    },
    academicStatusName: () => academicStatus => {
      switch (academicStatus) {
        case 1:
          return 'Current'
        case 2:
          return 'History'
        case 3:
          return 'Next'
        default:
          return ''
      }
    }
  },
  methods: {
    ...mapActions('studentInsurance', ['formViewModel']),
    async fetchAcademicYear() {
      this.ac_year_id = undefined
      this.acYearOptionns = []
      this.loading = true
      const response = await this.formViewModel({
        fnName: 'academic_year',
        branch_id: this.branch_id
      })
      this.loading = false

     const findCurrentAcYear = response.academic_year.find(a => a.branch_id == this.branch_id && a.ac_status_id == 1)

      if(findCurrentAcYear) {
        this.ac_year_id = findCurrentAcYear.ac_year_id
      }

      // Transform data and group by status
      const groupedData = response.academic_year.reduce((acc, ac) => {
        const status = this.academicStatusName(ac.ac_status_id)
        const option = {
          value: ac.ac_year_id,
          label: `${ac.ac_year}-${ac.branch_name_en}`
        }

        const existingGroup = acc.find(group => group.label === status)
        if (existingGroup) {
          existingGroup.options.push(option)
        } else {
          acc.push({
            label: status,
            options: [option]
          })
        }
        return acc
      }, [])
      this.acYearOptionns = groupedData
    },
    fetchData(attributes = {}) {
      this.loading = true
      return this.$store
        .dispatch('studentInsurance/fetch', {
          ...attributes,
          branch_id: this.branch_id,
          ac_year_id: this.ac_year_id,
          search: this.search,
          is_new_student: this.is_new_student,
          date_range: this.dateRange
        })
        .then(response => {
          this.RECEIVE_RESOURCES(response)
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    RECEIVE_RESOURCES(response) {
      this.resources = []
      response.data.forEach(resource => {
        this.resources.push(Object.assign(resource, { _deleting: false }))
      })
      if (response.hasOwnProperty('meta')) {
        this.pagination = new Pagination(
          mapKeys(response.meta, (v, k) => camelCase(k))
        )
      } else {
        let { data, ...meta } = response
        this.pagination = new Pagination(mapKeys(meta, (v, k) => camelCase(k)))
      }
    },
    exportExcel() {
      this.loading = true
      this.$store
        .dispatch('studentInsurance/insuranceExcel', {
          branch_id: this.branch_id,
          ac_year_id: this.ac_year_id,
          search: this.search,
          is_new_student: this.is_new_student
        })
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    },
    onEdit(record) {
      this.editData = record
      this.showModal = true
    },
    onCloseModal() {
      this.showModal = false
      this.editData = {}
      this.fetchData({
        branch_id: this.branch_id,
        ac_year_id: this.ac_year_id,
        search: this.search,
        is_new_student: this.is_new_student
      })
    },
    handleOrder(field) {
      // Check if the field is already in the orderBy array
      const currentSort = this.$data.currentSort || {}
      if (currentSort.field === field) {
        // Toggle direction if same field is clicked
        currentSort.ascending = !currentSort.ascending
      } else {
        // New field, default to ascending
        currentSort.field = field
        currentSort.ascending = true
      }
      this.$data.currentSort = currentSort

      this.resources = this.resources.sort((a, b) => {
        return currentSort.ascending
          ? a[field].localeCompare(b[field])
          : b[field].localeCompare(a[field])
      })
    },
    insurance(record) {
      this.studentInsurance = record
      this.showInsurance = true
    },
    onCloseModal() {
      this.studentInsurance = undefined
      this.showInsurance = false
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    }
  }
}
</script>
